// extracted by mini-css-extract-plugin
export var button = "newsletter-module--button--df0e7";
export var checkbox = "newsletter-module--checkbox--5bc92";
export var checkboxW = "newsletter-module--checkboxW--f3ce6";
export var form = "newsletter-module--form--975dd";
export var labelW = "newsletter-module--labelW--52ddc";
export var optin = "newsletter-module--optin--1aac6";
export var wrapperCheckbox = "newsletter-module--wrapperCheckbox--ca5cd";